module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-header"
  }, [_c('div', {
    staticClass: "sc-header--close-button",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "margin-top": "25%",
      "font-size": "1.3em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sc-header--team-name"
  }, [_vm._v(" " + _vm._s(_vm.teamName) + " ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24daacc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/Header.vue
// module id = 1217
// module chunks = 1